import { createAsyncThunk } from '@reduxjs/toolkit';
import { noticeError } from '@travel/tracker';

import { apiPath } from 'constants/api';

type LikePayload = {
  reviewId: string;
  isLiked: boolean;
};

export const setLike = createAsyncThunk<LikePayload, LikePayload, { extra: { apiClient: any } }>(
  'setLike/post',
  async (payload, { extra: { apiClient }, rejectWithValue }) => {
    try {
      await apiClient.patch(apiPath.setLike.pathname(payload.reviewId), {
        values: {
          like: payload.isLiked,
        },
      });

      return payload;
    } catch (error) {
      noticeError('Set Review Like Error', error);

      return rejectWithValue(error.message);
    }
  },
);
